module.exports = __webpack_public_path__ + "static/5-6dc997375ebf6177c4e21b75683eba05.jpg";